import { exports as slicedToArrayExports, __module as slicedToArray } from '../../../../_virtual/slicedToArray.js';
import { __require as requireArrayWithHoles } from './arrayWithHoles.js';
import { __require as requireIterableToArrayLimit } from './iterableToArrayLimit.js';
import { __require as requireUnsupportedIterableToArray } from './unsupportedIterableToArray.js';
import { __require as requireNonIterableRest } from './nonIterableRest.js';

var hasRequiredSlicedToArray;

function requireSlicedToArray () {
	if (hasRequiredSlicedToArray) return slicedToArrayExports;
	hasRequiredSlicedToArray = 1;
	(function (module) {
		var arrayWithHoles = requireArrayWithHoles();
		var iterableToArrayLimit = requireIterableToArrayLimit();
		var unsupportedIterableToArray = requireUnsupportedIterableToArray();
		var nonIterableRest = requireNonIterableRest();
		function _slicedToArray(arr, i) {
		  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
		}
		module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (slicedToArray));
	return slicedToArrayExports;
}

export { requireSlicedToArray as __require };
//# sourceMappingURL=slicedToArray.js.map
